import { ServiceDepartmentModule } from '@navio/nsdk';
import { noddiAsync, URLKeys } from 'noddi-async';
import { useMemo } from 'react';
import { useCurrentBrand } from '../stores/BrandStore/brandStore';

const PAGE_SIZE = 200;

export const useAvailableBrandModules = () => {
  const { currentBrand } = useCurrentBrand();

  const {
    data: brand,
    isPending: isBrandPending,
    error: brandError
  } = noddiAsync.useGet({
    type: URLKeys.getByDomainBrand,
    input: { brandDomain: currentBrand }
  });

  const {
    data: serviceDepartments,
    isPending: isDepartmentsPending,
    error: departmentsError
  } = noddiAsync.useGet({
    type: URLKeys.getPaginatedServiceDepartments,
    input: {
      brandIds: brand ? [brand.id] : [],
      pageSize: PAGE_SIZE,
      pageIndex: 0
    },
    queryConfig: {
      enabled: !!brand
    }
  });

  const availableModules = useMemo(() => {
    const modules = new Set<ServiceDepartmentModule>();
    for (const department of serviceDepartments?.results ?? []) {
      for (const module of department.modules) {
        modules.add(module);
      }
    }
    return modules;
  }, [serviceDepartments]);

  return {
    availableModules,
    isLoading: isBrandPending || isDepartmentsPending,
    error: brandError ?? departmentsError
  };
};
